module.exports = __webpack_public_path__ + "f8ea486d1d604995e971e25f7759e54a.png";